export function backButton(root = document) {
    root.querySelectorAll('[data-history-back]').forEach((link) => {
        if (link.dataset.historyBackInitialized) return;
        link.dataset.historyBackInitialized = 'true';

        link.addEventListener('click', (event) => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            if (window.history.length < 2) return;

            event.preventDefault();
            window.history.back();
        });
    });
}
